import { AlertBannerToast } from "./alert-banner-toast";
import { AlertInfo } from "./alert-info";
import { AlertSection } from "./alert-section";
import { AlertProps } from "./types";

export const Alert = ({ variant = "banner", ...variantProps }: AlertProps) => {
  const variants = {
    banner: AlertBannerToast,
    section: AlertSection,
    toast: AlertBannerToast,
    info: AlertInfo,
  };

  const Component = variants[variant];

  return <Component variant={variant} {...variantProps} />;
};
